import React, { PureComponent } from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import Cookies from 'universal-cookie';
import { FormattedMessage } from 'react-intl';
import notificationPermissions from '@/enums/notificationPermissions';
import styles from './EnableNotificationPrompt.module.scss';

const cookie = new Cookies();
const COOKIE_MAX_AGE = 86400 * 180; // 180 days
const COOKIE_NAME = 'enableNotificationPrompt';
const COOKIE_BODY = 'dismissed';

type Props = {
    forceEnableNotificationsBanner: Function;
    hasNotifications: boolean;
    permission: string;
    requestBrowserPermission: Function;
};

type State = {
    dismissed: boolean;
};

export default class EnableNotificationPrompt extends PureComponent<Props, State> {
    state = {
        dismissed: false,
    };
    componentDidMount = () => {
        this.isBannerDismissed();
    };

    isBannerDismissed = () => {
        const hasBeenChecked = cookie.get(COOKIE_NAME);
        this.setState({ dismissed: COOKIE_BODY === hasBeenChecked });
        return COOKIE_BODY === hasBeenChecked;
    };

    onClickApprove = () => {
        if (this.props.permission === notificationPermissions.DENIED) {
            this.props.forceEnableNotificationsBanner();
        } else {
            this.props.requestBrowserPermission();
        }
    };

    onClickRiskIt = () => {
        cookie.set(COOKIE_NAME, COOKIE_BODY, { maxAge: COOKIE_MAX_AGE });
        this.setState({ dismissed: true });
    };

    render() {
        const { hasNotifications, permission } = this.props;
        if (this.state.dismissed || permission === notificationPermissions.GRANTED || !hasNotifications) {
            return null;
        }
        return (
            <>
                <div className={styles.promptContainer}>
                    <div className={styles.promptTitle}>
                        <FormattedMessage id="notifications.enable_notifications_prompt_title" />
                    </div>
                    <div className={styles.promptBody}>
                        <FormattedMessage id="notifications.enable_notifications_prompt_body" />
                    </div>
                    <div className={styles.buttons}>
                        <Button className={styles.button} onClick={this.onClickApprove} primary small>
                            <FormattedMessage id="notifications.yes" />
                        </Button>
                        <Button
                            className={styles.button}
                            contentClassName={styles.buttonContent}
                            onClick={this.onClickRiskIt}
                            secondary
                            small
                        >
                            <FormattedMessage id="notifications.risk_it" />
                        </Button>
                    </div>
                </div>
                <hr />
            </>
        );
    }
}
